import { type HttpClient } from '@/application/interfaces/http-client';

import { getBannerInstallApp } from './get-banner-install-app';

const AppService = (httpClient: HttpClient.Instance) => ({
  getBannerInstallApp: getBannerInstallApp(httpClient),
});

export default AppService;
